/* eslint-disable multiline-ternary */
import { renderToString } from 'react-dom/server'
import tokens from 'mondrian-tokens/dist/claro-tokens-latest.common'
import React from 'react'

export function useSwipper({
  navigationPrevRef,
  navigationNextRef,
  paginationElementRef
}) {
  const hasNavigation = (children) => {
    return [...children].length > 1
      ? {
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current
      }
      : {}
  }

  const hasPagination = (children, pagination) => {
    return {
      el: '.mdn-SwiperSlide-pagination.mdn-Swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  }

  const setSwipperAttrs = (props, swiperRef) => {
    const {
      children,
      slidesPerView,
      slidesPerViewMobile,
      slidesPerViewTablet,
      slidesPerViewSmallDesktop,
      sliderDelay,
      spaceBetween,
      spaceBetweenMobile,
      spaceBetweenTablet,
      spaceBetweenSmallDesktop,
      autoPlay,
      breakpoints,
      customParams = {},
      pagination
    } = props

    const mdnslidesPerView = Number(slidesPerView || 'auto')

    const mdnslidesPerViewMobile = Number(slidesPerViewMobile || '1')
    const mdnslidesPerViewTablet = Number(slidesPerViewTablet || '1')

    const mdnslidesPerViewSmallDesktop = Number(
      slidesPerViewSmallDesktop || '1'
    )
    const mdnSliderDelay = Number(sliderDelay || 5000)

    const mdnSpaceBetween = Number(
      spaceBetween || tokens.spacingInlineXs.replace('px', '')
    )

    const mdnSpaceBetweenMobile = Number(
      spaceBetweenMobile || tokens.spacingInlineXs.replace('px', '')
    )
    const mdnSpaceBetweenTablet = Number(
      spaceBetweenTablet || tokens.spacingInlineXs.replace('px', '')
    )
    const mdnSpaceBetweenSmallDesktop = Number(
      spaceBetweenSmallDesktop || tokens.spacingInlineXs.replace('px', '')
    )

    const __breakpoints = {}

    if (slidesPerViewMobile && slidesPerViewMobile != 'auto') {
      __breakpoints[320] = {
        slidesPerView: isNaN(mdnslidesPerViewMobile)
          ? 'auto'
          : mdnslidesPerViewMobile,
        spaceBetween: isNaN(mdnSpaceBetweenMobile)
          ? 'auto'
          : mdnSpaceBetweenMobile
      }
    }
    if (slidesPerViewTablet && slidesPerViewTablet != 'auto') {
      __breakpoints[tokens.screenSizeMd.replace('px', '')] = {
        slidesPerView: isNaN(mdnslidesPerViewTablet)
          ? 'auto'
          : mdnslidesPerViewTablet,
        spaceBetween: isNaN(mdnSpaceBetweenTablet)
          ? 'auto'
          : mdnSpaceBetweenTablet
      }
    }
    if (slidesPerViewSmallDesktop && slidesPerViewSmallDesktop != 'auto') {
      __breakpoints[tokens.screenSizeXl.replace('px', '')] = {
        slidesPerView: isNaN(mdnslidesPerViewSmallDesktop)
          ? 'auto'
          : mdnslidesPerViewSmallDesktop,
        spaceBetween: isNaN(mdnSpaceBetweenSmallDesktop)
          ? 'auto'
          : mdnSpaceBetweenSmallDesktop
      }
    }

    const params = {
      containerClass: 'mdn-Swiper-container',
      wrapperClass: 'mdn-Swiper-wrapper',
      slideClass: 'mdn-Swiper-slide',
      slidesPerView: isNaN(mdnslidesPerView) ? 'auto' : mdnslidesPerView,
      spaceBetween: isNaN(mdnSpaceBetween) ? 'auto' : mdnSpaceBetween,
      watchOverflow: true,
      autoplay: autoPlay ? { delay: mdnSliderDelay } : false,
      pagination: React.Children.toArray(children).length > 1 ? hasPagination(children, pagination) : {},
      navigation: (React.Children.toArray(children).length > 1 && swiperRef) ? hasNavigation(children) : {},
      breakpoints: breakpoints || __breakpoints
    }

    return {
      ...params,
      ...customParams
    }
  }
  return {
    setSwipperAttrs
  }
}
